"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (matchString) {
  var positiveLookAhead = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var extraWordBoundary = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
  var locale = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
  var wordBoundary, wordBoundaryStart, wordBoundaryEnd;

  if (locale === "id_ID") {
    wordBoundary = "[ \\u00a0\xA0\\n\\r\\t.,()\u201D\u201C\u301D\u301E\u301F\u201F\u201E\"+;!\xA1?\xBF:/\xBB\xAB\u2039\u203A" + extraWordBoundary + "<>";
  } else {
    /*
     * \u00a0 - no-break space
           * \u06d4 - Urdu full stop
           * \u061f - Arabic question mark
           * \u060C - Arabic comma
           * \u061B - Arabic semicolon
           */
    wordBoundary = "[ \\u00a0\\u06d4\\u061f\\u060C\\u061B\xA0\\n\\r\\t.,()\u201D\u201C\u301D\u301E\u301F\u201F\u201E\"+\\-;!\xA1?\xBF:/\xBB\xAB\u2039\u203A" + extraWordBoundary + "<>";
  }

  wordBoundaryStart = "(^|" + wordBoundary + "'‘’‛`])";

  if (positiveLookAhead) {
    wordBoundaryEnd = "($|((?=" + wordBoundary + "]))|((['‘’‛`])(" + wordBoundary + "])))";
  } else {
    wordBoundaryEnd = "($|(" + wordBoundary + "])|((['‘’‛`])(" + wordBoundary + "])))";
  }

  return wordBoundaryStart + matchString + wordBoundaryEnd;
};